import cx from 'classnames'
import Shared from '../../Shared.module.scss'
import { ReactComponent as ProgressCheckMark } from './check-02.svg'
import { ReactComponent as ChevronRightProgress } from './chevronRightProgress.svg'

type Props = {
  totalSteps: number
  currentStep: number
}

const stepText = (number: number): string => {
  if (number === 0) return 'Verify'
  if (number === 1) return 'Account'
  if (number === 2) return 'Info'
  if (number === 3) return 'Plan'
  return ''
}

const ProgressBar = ({ totalSteps, currentStep }: Props) => (
  <div className={Shared.progressBar} data-testid="progress-bar">
    {[...Array(totalSteps)].map((_, step) => (
      <div key={step} className={cx(Shared.progressSection)}>
        <span
          className={cx(Shared.progressDot, {
            [Shared.current]: currentStep === step + 1,
            [Shared.complete]: currentStep > step + 1,
            [Shared.incomplete]: currentStep < step + 1,
          })}
        >
          {currentStep > step + 1 ? <ProgressCheckMark /> : step + 1}
        </span>
        <span
          className={cx(Shared.progressSection, {
            [Shared.current]: currentStep === step + 1,
            [Shared.complete]: currentStep > step + 1,
            [Shared.incomplete]: currentStep < step + 1,
          })}
        >
          {stepText(step)}
        </span>
        {step !== totalSteps - 1 && <ChevronRightProgress className={Shared.chevronRight} />}
      </div>
    ))}
  </div>
)

export default ProgressBar
